import { useTranslation } from 'react-i18next';
import { LANGUAGES } from 'utils/Constants';
import { CustomLanguageAutocomplete } from 'components/shared/DropDown/CustomLanguageAutocomplete';

export const LanguageSelector = ({
    selectedLanguage,
    onLanguageChange,
    labelClassName = 'um-label',
}) => {
    const { t } = useTranslation();

    return (
        <>
            <span className={labelClassName}>{t('Langue')}*</span>

            <CustomLanguageAutocomplete
                disabled={!LANGUAGES.length}
                list={LANGUAGES}
                value={selectedLanguage}
                getOptionDisabled={() => false}
                setValue={onLanguageChange}
                groupBy={() => false}
                getOptionLabel={(option) => t(option.language)}
            /*inputClassName="um-autocomplete-input"   */
            />
        </>
    );
};